import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'who_responsible_paying_recruitment_fees_related_costs_worker'

export const dataPointDefinition = {
  retracedId: 'who_responsible_paying_recruitment_fees_related_costs_worker',
  name: 'Who is responsible for paying recruitment fees and related costs, the worker or the facility?',
  description:
    'The terms "recruitment fees" or "related costs" refer to any fees or costs incurred in the recruitment process in order for workers to secure employment or placement, regardless of the manner, timing or location of their imposition or collection. ',
  meta: {
    slcpMeta: {
      key: 'fl-4',
      number: 'RH-REC-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fl-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27090,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
